import React, { useState } from 'react';
import { TextReveal } from './TextReveal';
import { MeetingModal } from './MeetingModal';
export function CTA() {
  const [isOpen, setIsOpen] = useState(false);
  return <>
      <section id="cta" className="py-32 md:py-48 bg-bg flex flex-col items-center justify-center text-center px-6" data-id="element-21">
        <div className="max-w-5xl mx-auto" data-id="element-22">
          <TextReveal text="BEREIT FÜR DEN NÄCHSTEN SCHRITT?" as="h2" className="text-[clamp(2rem,5vw,5rem)] font-black leading-[0.9] text-white tracking-tighter mb-6" data-id="element-23" />

          <TextReveal text="Vereinbaren Sie ein unverbindliches Erstgespräch." as="p" className="text-lg md:text-xl text-muted mb-12" delay={0.2} data-id="element-24" />

          <div className="inline-block overflow-hidden" data-id="element-25">
            <button onClick={() => setIsOpen(true)} className="group relative bg-lime text-bg px-10 py-5 text-lg font-bold uppercase tracking-wide transition-all duration-300 hover:scale-[1.22] hover:brightness-110 focus:outline-none focus:ring-2 focus:ring-lime focus:ring-offset-2 focus:ring-offset-bg" data-id="element-26">
              <span className="relative z-10" data-id="element-27">ERSTGESPRÄCH VEREINBAREN</span>
            </button>
          </div>
        </div>
      </section>

      <MeetingModal isOpen={isOpen} onClose={() => setIsOpen(false)} data-id="element-28" />
    </>;
}